import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import { clearUserInfo, getUserInfo } from './login'
let userInfo = null

const http = (method, postType, path, data, isCatch) => {
    return new Promise((resolve, reject) => {
        const SEVER_PATH = window.NUWA_SEVER_PATH

        if (!userInfo) {
            userInfo = getUserInfo()
        }
        const headers = {
            channel: 'h5',
            ['content-Type']: 'application/json',
        }
        if (userInfo) {
            headers['token'] = userInfo.token
        }
        if (postType === 'form') {
            headers['content-Type'] = 'application/x-www-form-urlencoded'
        }
        const params = postType === 'form' ? qs.stringify(data) : data

        axios({
            method,
            url: SEVER_PATH + path,
            headers: headers,
            data: params,
            withCredentials: true,
        })
            .then((res) => {
                if (res.status == 200 && res.data.code === 200) {
                    resolve(res.data)
                } else if (res.data.code === 401) {
                    clearUserInfo()
                    window.location.reload()
                } else {
                    if (isCatch) {
                        reject(res)
                    }
                    Toast(res.data.message)
                }
            })
            .catch((err) => {
                if (isCatch) {
                    reject(err)
                }
                Toast(JSON.stringify(err))
            })
    })
}

export const getQuestionList = (data) => {
    return http('POST', 'form', '/questionPaper/getQuestions', data)
}
export const commitAnswer = (userId, courseInfo, data) => {
    let params = `userId=${userId}&paperNo=${courseInfo.paperNo}`
    if (!courseInfo.paperNo) {
        params = `userId=${userId}&paperId=${courseInfo.paperId}&courseId=${courseInfo.courseId}`
    }
    return http('POST', '', `/questionPaper/commitAnswer?${params}`, data)
}
export const getPaperInfo = (data) => {
    return http('POST', 'form', '/questionPaper/get', data)
}
export const getLastCommitAnswer = (data) => {
    return http('POST', 'form', `/questionPaper/getLastCommitAnswer`, data)
}

export const getCommitAnswer = (data) => {
    return http('POST', '', `/questionPaper/commit/getUserAnswer`, data)
}

export const getAnalysis = (data) => {
    return http('POST', 'form', '/questionPaper/getAnalysis', data)
}

// 评价
export const userEvaluation = function (data) {
    const userInfo = getUserInfo()
    return http('POST', '', '/course/evaluation', {
        ...data,
        userId: userInfo.id,
    })
}

// app 新闻外刊
export const getArticleDetail = (data) => {
    return http('POST', 'form', '/vocabArticle/get', data, true)
}

export const getArticleWords = (data) => {
    return http('POST', 'form', '/vocabArticle/words', data)
}

export const queryPosts = (data) => {
    return http('POST', '', '/bbs/posts', data)
}

export const getRandomEvaluations = (data) => {
    return http('POST', 'form', '/coursePackage/randomEvaluations', data)
}

export const getJoinStepProgress = (data) => {
    return http('POST', 'form', '/clazzStudent/joinStep/progress', data)
}
export const joinStepComplete = (data) => {
    return http('POST', 'form', '/clazzStudent/joinStep/complete', data)
}

export const getStepList = (data) => {
    return http('POST', 'form', '/clazzStudent/joinStep/list', data)
}

export const getUserCert = (data) => {
    return http('POST', 'form', '/app/user/cert', data)
}

export const commitQuesiton = function (data) {
    const params = `paperNo=${data.paperNo}&userId=${data.userId}&batchId=${data.batchId}`
    return http('POST', '', `/questionSurvey/commit?${params}`, data.data, true)
}
export const getLastQuestionSurvey = function (data) {
    return http('POST', 'form', '/questionSurvey/last', data)
}
export const getAppNacosConfig = function (data) {
    return http('POST', 'form', '/app/nacos/config/get', data)
}
